import axios from "axios";

export const notificationMarkAsReadAll = async (id, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/notificationMarkAsReadAll/${id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
